import { Button, Col, Form, Input, notification, Row, Switch } from "antd"
import { useState } from "react";
import { useEffect } from "react";
import { PHONE_PATTERN } from "../../../config/constant";

export const EditUserDetail = (props) => {
    const [form] = Form.useForm();

    const [priviewImg, setPriviewImg] = useState()
    const [file, setfile] = useState()

    useEffect(() => {
        form.setFieldsValue({
            'name': props?.userData?.name,
            'phone': props?.userData?.phone,
            'address': props?.userData?.address,
        })
    }, [])

    const onFinish = (values) => {
        // console.log(values);
    };
    const resetData = () => {
        form.resetFields()
    };
    // function to display an selected image
    const imagePreview = (e) => {
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setPriviewImg(objectUrl)
        setfile(e.target.files[0])
    }

    return (
        <Form
            name="addPlanPricingForm"
            className="addPlanPricingForm"
            form={form}
            onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">Edit Account Info</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                <Col xs={24} md={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Name
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter name!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Name" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Phone
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="phone"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Phone!",
                            },
                            {
                                pattern: PHONE_PATTERN,
                                message: "Please Enter valid Phone!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Phone No" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Address
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="address"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Address!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Address" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Image
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="image"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Image!",
                            },
                        ]}
                    >
                        <Input type="file" onChange={(e) => imagePreview(e)} className="mt-2 p-1" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={11} xxl={4}>
                    {file && (
                        <img src={priviewImg || ''} alt="360" width={100} />
                    )}
                </Col>
                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        UPDATE
                    </Button>
                    <Button onClick={() => props.setUserDetailModalVisible(false)} className="reset-button ms-4 b-0 rounded">
                        RESET
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}